import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { CodigosNomina } from '../models/codigosNomina';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/CodigosNomina';

@Injectable({
  providedIn: 'root'
})
export class CodigosNominaService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  list(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/List' })
  }

  save(codigosNomina: CodigosNomina, cortarRegistro: boolean)
  {
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: codigosNomina });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

  listAgrupada(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/ListAgrupada' })
  }
}

